import React, { useEffect, useRef, useState } from 'react';
import Card from '../../../../CustomComponents/Card';
//  import { width, height } from "../../../../CustomComponents/Card/CardStyles";
import { Tabs, Tab } from '../../../../CustomComponents/TabsComponent';
import TransactionItemWidget from '../../../../CustomComponents/TransactionItemWidget';
import DepositCashImage from '../../../../../assets/images/depositCash.png';
import { useTranslation } from "react-i18next";
import right_dropdown_arrow from '../../../../../assets/images/right_dropdown_arrow.png';
import FooterContent from '../../../../CustomComponents/Footer';
import downloadArrow from '../../../../../assets/images/download_arrow.png';
import { GET_DDA_DETAILS, GET_RELOAD_DETAILS, STATUS_SUCCESS_CODE } from '../../../../../network/URLConstants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme, retrieveData } from '../../../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../../network/NetworkUtils';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../../Layout/HomeLayout';
import HomeHeader from '../../../../CustomComponents/HomeHeader';
import DynamicCard from '../../../../CustomComponents/DynamicCard';
import { width, height } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles';
import AccountDetailView from '../../../../CustomComponents/AccountDetailView';
import RightArrow from '../../../../../assets/images/right_dropdown_arrow.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountDetailsHeder, copyToClipboard, QuickActions, MoreServices, addLineBreaks } from '../../../../../utils';
import CustomAlertModel from '../../../../CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import CustomModalPlus from '../../../../../kudzu_plus/helpers/customModalPlus';
import CardHeading from '../../../../CustomComponents/CardHeading';

const SMIDepositCash = () => {
    const { t } = useTranslation();

    // Set page title immediately
    document.title = t("page_title_deposit_cash_smione");

    // Set page title in useEffect as backup
    useEffect(() => {
        document.title = t("page_title_deposit_cash_smione");
    }, [t]);

    const moreService = 'w-[90%] pb-[1.5rem] flex justify-between items-center border-b-[3px] border-[#D1E7DD]';
    const moreserviceText = 'font-[600] text-[#262B3A] md:text-[16px] sm:text-[11px] leading-[16px] font-hanken-grotesk';

    const navigate = useNavigate();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [accountNumber, setAccountNumber] = useState(''); 
    const [routingNumber, setRoutingNumber] = useState('');
    const [accountCopied, setAccountCopied] = useState(false);
    const [routingCopied, setRoutingCopied] = useState(false);
    const [imageLink, setImageLink] = useState('');
    const [infoMessage, setinfoMessage] = useState('');
    const [infoMessage2, setinfoMessage2] = useState('');
    const [redirectUrl, setRedirectUrl] = useState('');
    const [cardData, setCardData] = useState([]);
    const [loading, setLoading] = useState(false)
    const selectedItem = cards?.find(item => item.AccountTypeBit63 === 1).CardKey;
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)]  cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "text-[var(--modal-text-heading-clr)] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)]  lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
    const SubHeaderMsgPlusStyles = "font-hanken-grotesk modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none text-white";
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [type, setType] = useState('')
    const [footerMsg, setFooterMsg] = useState('');
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState(false);
    const dispatch = useDispatch()
    const currentpath = useLocation()
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const [infoTitle , setInfoTitle] = useState("")
    const [showVisaReadyLinkContent, setShowVisaReadyLinkContent]=useState("")


    const moreServicesArray = [
        { name: 'Manage Direct Deposit', actionType: '', path: "/AccountServices/smiONECard/AddFunds/ManageDirectDeposit" },

    ];

    useEffect(() => {
        getDdaDetails();
        getLinkandImageData();
    }, []);


    const getDdaDetails = async () => {
    
      
        setLoading(true)
        let url = GET_DDA_DETAILS + selectedItem;
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        var response = await GetRequest(url, headers)
        setTimeout(() => {
            setLoading(false)
        }, 500);
        var responseObj = JSON.parse(response);
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            if (responseObj.Response != undefined) {
                setAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
                setRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
            }
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;

        }
    }
 
    const getLinkandImageData = async () => {
      
        
        const url = GET_RELOAD_DETAILS + "?cardKey=" + selectedItem;
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        setLoading(false)
        var response = await GetRequest(url, headers);
        var responseObj = JSON.parse(response);

        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setTimeout(() => {
                setImageLink(kudzuPlusTrue ? responseObj.Response.Items[0].DarkImageUrl : responseObj.Response.Items[0].ImageUrl);
                setinfoMessage(responseObj.Response.text_Part1);
                let textPart2 = responseObj.Response.text_Part2;
                 
                 setShowVisaReadyLinkContent(responseObj.Response.provider)
               

                // Set the updated HTML content
              if (textPart2 && textPart2.includes('cardholder')) {
                    textPart2 = textPart2.replace(
                        /<a href="cardholder"[^>]*>([^<]*)<\/a>/g,
                        '<span class="cardholder" style="text-decoration: underline; cursor: pointer; color: inherit;">$1</span>'
                    );
                }


                // Set the updated HTML content
                setinfoMessage2(textPart2);
               // setinfoMessage2(responseObj.Response.text_Part2);
                setRedirectUrl(responseObj.Response.Items[0].RedirectUrl);
                setCardData(responseObj.Response.Items);
                setInfoTitle(responseObj.Response.Title)
                setLoading(false);
            }, 1000);

        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;

        }
    }

    const cardKey = cards?.find(card => card.AccountTypeBit63 === 1)?.CardKey;

    const handleDepositTermsClick = () => {
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
            return;
        }
        else {
            navigate('/Documents/smiONE/Policies/Cardholder%20Agreement', {
                state: {
                    name: 'Cardholder Agreement',
                    url: "TnC",
                    accType: 1,
                    CardKey: cardKey
                }
            });
        }
    }

       const [agreementType, setAgreementType] = useState([
            {
            name: "Cardholder Agreement",
            url: "TnC",
            accType: 1,
            CardKey: cardKey,
            }
        ]);
    
      const redirectToPolicy = (policyName) => {
     
        const selectedAgreementType = agreementType.find(agreement => agreement.url === policyName);
        dispatch({
            type: "UPDATE_AGREEMENT_TYPE",
            payload: { documentAgreementType: selectedAgreementType },
          });
        navigate(`/Documents/smiONE/Policies/${selectedAgreementType.name}`);
      };

    const depositCashClicked = () => {
        navigate('/AccountServices/smiONECard/AddFunds/ManageDirectDeposit');
    }
    const findLocationClicked = () => {
        logFirebaseEvents("Account_services", "Find_location_cliked", "Find_location_cliked", "", "");
        showAlertModal(true, t("heads_up"), t("about_to_leave_kudzu"), t("redirected_from_kudzu"), true, true, t("continue"), t("cancel"), true, '')
    }

    const commonHeadingStyle = {
        fontSize: '20px',
        color: 'blue',
    };

    const leftHeadingStyle = {
        color: '#559C7E',
        marginTop: '10px',
        fontSize: '16px',
        lineHeight: '1.5',
        fontWeight: 'bold',
    };

    const leftContentStyle = {
        color: 'black',
        marginTop: '10px',
        fontSize: '16px',
        lineHeight: '1.8',
        fontWeight: 'normal',
    };

    const rightHeadingStyle = {
        color: '#559C7E',
        margin: '10px 0px 0px 150px',
        fontSize: '16px',
        lineHeight: '1.5',
        fontWeight: 'bold',
    };

    const rightContentStyle = {
        color: 'black',
        margin: '10px 0px 0px 150px',
        fontSize: '16px',
        lineHeight: '1.8',
        fontWeight: 'normal',
    };

    const exploreClimb = () => {
        // navigate('/Climb');'
        navigate('/AccountServices/smiONECard/AddFunds/ManageDirectDeposit')
        showAlertModalPlus(true, t(""), addLineBreaks(t("earn_1.25_apy_on_your_savings_account_with_kudzu+")), addLineBreaks(t('learn_and_grow_with_a_free_3_month_kudzu_upgrade')), true, true, t('Learn_More'), t('No_Thanks'), true, require('.././../../../../assets/kudzu-plus-images/savingsTransferPlusbanner.png'), "", true, "#262B3A", addLineBreaks(t('4.95_per_month_after_first_3_month_after_charged_automatically_cancel_anytime')), true, '', false, false, true, true);

    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
    }
    const footerContent = () => {
        return (
            < FooterContent highlightText={t("set_up_dd_text")}
                subHeaderText={t("paper_work")} image={appThemeData.downArrowIconAddfunds}
                buttonEnabled={true} isSubheadingwidth={true} buttonText={t("set_up_dd_btn")}
                footerBtnAction={exploreClimb} />
        )

    }
    const headerContent = () => {
        const dynamicColor = "#262B3A";
        return (

            <div className="flex flex-row justify-between mx-0 items-center mt-12">
                <p className="font-hanken-grotesk font-medium text-${dynamicColor}`} ">
                    {t("add_cash")}
                </p>
            </div>
        )
    }
    const accountNumberCopiedClicked = () => {
        logFirebaseEvents("Account_services", "account_Number_copied", "account_Number_copied", "", "");
        copyToClipboard(accountNumber, setAccountCopied(true))
        setAccountCopied(true);
        setTimeout(() => {
            setAccountCopied(false);
        }, 2000);

    }
    const routingNumberCopiedClicked = () => {
        logFirebaseEvents("Account_services", "routing_Number_copied", "routing_Number_copied", "", "");
        copyToClipboard(routingNumber, setRoutingCopied(true))
        setRoutingCopied(true);
        setTimeout(() => {
            setRoutingCopied(false);
        }, 2000);
    }
    const onclickManageDirectDeposit = () => {
        navigate('/AccountServices/smiONECard/ManageDirectDeposit')
    }
    const onclickDepositCheck = () => {
        alert("we will update soon")
    }

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }

    const closeCustomAlertModal = () => {
        setShowModel(false);
    }
    const onAcptBtnClick = async () => {
        setShowModel(false);
        if (redirectUrl) {
            window.open(redirectUrl, "_blank");
        }

    }
    const onCancelBtnClick = () => {
        setShowModel(false);

    }
    const onCancelBtnClickPlusModal = () => {
        // localStorage.setItem('plusModalClosed', 'true');
        setShowPlusModal(false)
    }



    const onAcptBtnClickPlusModal = () => {
        setShowPlusModal(false)
        const currentPath = { currentPathFromStore: currentpath.pathname };
        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
        setShowCarouselScreensShow((prev) => !prev);
        // navigate("/memnershipEnrollmentScreens")
        // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
        const data = { kudzuFlowFrom: "login" };
        dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
    }


    const closeModelPlus = () => {
        setShowPlusModal(false);
        setShowCarouselScreensShow(false);
    }
    return (
        <>

            <HomeLayout>
                <HomeHeader heading="" isHeaderCaption={false} selectedIndex={1} />
                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight  '>
                    <DynamicCard
                        header={false}
                        footer={true}
                        CardRadius={true}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        headerContent={headerContent()}
                        cardWidth={width.homeCard}
                        cardHeight={height.depositMoney}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={t("Load Cash")} />
                            </>
                        }
                    >

                        <div>
                            <AccountDetailsHeder
                                handleCopyClick={accountNumberCopiedClicked}
                                handleCopyRoutingNumberClick={routingNumberCopiedClicked}
                                accountCopiedProps={accountCopied}
                                routingCopiedProps={routingCopied}
                                AccountNo={accountNumber}
                                routingNo={routingNumber}
                                contentBetween={true}
                                topBorder={appThemeData.borderTopForAccServices}
                                bottomBorder={true}
                                isCopyblack={true}
                            />

                        </div>
                        {showVisaReadyLinkContent === "VisaReady" ? 
                        (<>
                                    <div>
                                   
                                                               <p className='font-hanken-grotesk text-[var(--primary-text-cards)] 
                                         uppercase   lg:text-[13px] md:text-[12px] 
                                         sm:text-[11px] text-[13px] 
                                         font-[600] tracking-[2px] md:pb-8 py-8 sm:mx-0 mx-4'>visa readylink</p>
                                                               {imageLink && (
                                                                   <div className="flex justify-center items-center">
                                                                       <img
                                                                           src={imageLink}
                                                                           alt="AddCash"
                                                                           className={`${!infoMessage ? 'mb-8' : ''} 
                                                   ${kudzuPlusTrue ? '' : 'lg:w-[198px] lg:h-[118px] md:w-[168px] md:h-[98px] sm:w-[120px] sm:h-[72px] w-[120px] h-[70px]'}`}
                                                                       />
                                                                   </div>
                                                               )}
                                   
                                   
                                                               {infoMessage && <div className='w-full flex justify-center items-center'>
                                                                   <div className='md:w-[533px] w-[295px] py-10'>
                                   
                                                                       <p className='font-[500] text-[var(--text-clr-transactions)] mb-[2rem] lg:text-[20px] md:text-[20px] 
                                                                   sm:text-[13px] md:leading-[30px] sm:leading-[19px] text-[16px] leading-[24px] font-hanken-grotesk'>
                                                                           {infoMessage}
                                                                       </p>
                                                                       <div className=' flex sm:flex-col flex-col-reverse gap-12'>
                                                                           <div className='font-[400] text-[var(--text-clr-transactions)] sm:font-[500]  lg:text-[18px] md:text-[18px] 
                                                                        sm:text-[10px] md:leading-[28px] sm:leading-[16px] text-[12px] leading-[18px] font-hanken-grotesk' dangerouslySetInnerHTML={{ __html: infoMessage2 }}>
                                                                           </div>
                                                                           <div
                                                                               tabIndex={0}
                                                                               onKeyDown={(event) => {
                                                                                   if (event.key === "Enter") {
                                                                                       event.preventDefault();
                                                                                       findLocationClicked();
                                                                                   }
                                                                               }}
                                                                               onClick={findLocationClicked} >
                                   
                                                                               <div className="md:text-[16px] sm:text-[12px] font-[600] sm:font-[700] text-[16px]
                                                               h-[60px] text-[var(--findlocation-text)] sm:text-[var(--findlocation-text)]
                                                                sm:bg-[var(--findlocationBG)] w-full flex border-[2.5px] 
                                                                border-[var(--findlocationBtn)] bg-[var(--findlocationBG)]
                                                                justify-center items-center cursor-pointer">
                                                                                   {t("find_location")}
                                                                               </div>
                                   
                                                                           </div>
                                   
                                                                       </div>
                                                                   </div>
                                                               </div>}
                                   
                                                               {/* /////more service */}
                                                               <div className="h-auto border-t-[2.5px] border-[var(--transactions-acc-number-border)] flex flex-col justify-center sm:mx-0 mx-4">
                                                                   <MoreServices actionsArray={moreServicesArray} />
                                                               </div>
                                                           </div>
                        </>) : 
                        (<>
                         <div>

                            <p className='font-hanken-grotesk text-[var(--primary-text-cards)] 
      uppercase   lg:text-[13px] md:text-[12px] 
      sm:text-[11px] text-[13px] 
      font-[600] tracking-[2px] md:pb-8 py-8 sm:mx-0 mx-4'>{infoTitle}</p>
                            {imageLink && (
                                <div className="flex justify-center items-center">
                                    <img
                                        src={imageLink}
                                        alt="AddCash"
                                        className={`${!infoMessage ? 'mb-8' : ''} 
                                     ${kudzuPlusTrue ? '' : 'lg:w-[278px] lg:h-[118px] md:w-[168px] md:h-[98px] sm:w-[120px] sm:h-[72px] w-[120px] h-[70px]'}`}
                                    />
                                </div>
                            )}


                            {infoMessage && <div className='w-full flex justify-center items-center'>
                                <div className='md:w-[533px] w-[295px] py-10'>

                                    <p className='font-[500] text-[var(--text-clr-transactions)] mb-[2rem] lg:text-[20px] md:text-[20px] 
                                sm:text-[13px] md:leading-[30px] sm:leading-[19px] text-[16px] leading-[24px] font-hanken-grotesk'>
                                        {infoMessage}
                                    </p>
                                                  
                               <div
                               className='mb-12'
                                            tabIndex={0}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    findLocationClicked();
                                                }
                                            }}
                                            onClick={findLocationClicked} >
                                            <div className="md:text-[16px] sm:text-[12px] font-[600] sm:font-[700] text-[16px]
                            h-[60px] text-[var(--findlocation-text)] sm:text-[var(--findlocation-text)]
                             sm:bg-[var(--findlocationBG)] w-full flex border-[2.5px] 
                             border-[var(--findlocationBtn)] bg-[var(--findlocationBG)]
                             justify-center items-center cursor-pointer">
                                                {t("find_location")}
                                            </div>

                                        </div>

                                    <div className=' flex sm:flex-col flex-col-reverse gap-12'>
                                        <div className='font-[400] text-[var(--text-clr-transactions)] sm:font-[400]  lg:text-[14px] md:text-[18px] 
                                            }}
                                     sm:text-[10px] md:leading-[28px] sm:leading-[16px] text-[12px] leading-[18px] font-hanken-grotesk uppercase' dangerouslySetInnerHTML={{ __html: infoMessage2 }} 
                                      onClick={(e) => {
                                                // Check if the clicked element is the cardholder agreement link
                                                if (e.target.classList.contains('cardholder')) {
                                                    e.preventDefault();
                                                    redirectToPolicy("TnC")
                                                }
                                            }}
>
                                        </div>
                                       

                                    </div>
                                </div>
                            </div>}
                           

                            {/* /////more service */}
                            <div className="h-auto border-t-[2.5px] border-[var(--transactions-acc-number-border)] flex flex-col justify-center sm:mx-0 mx-4">
                                <MoreServices actionsArray={moreServicesArray} />
                            </div>
                        </div>
                        </>)}
                        
                    </DynamicCard>
                </div>

            </HomeLayout>
            <CustomAlertModel isOpen={showModel}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
            />
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
            />
        </>

    )
}
export default withOidcSecure(SMIDepositCash);


